import {svgIconWrapper} from '../svg-icon-wrapper';

import AdminDigestRegularAi from './admin-digest-regular-ai-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <AdminDigestRegularAi {...props} />;
}

SvgComponent.iconName = 'adminDigestRegularAi';

export const AdminDigestRegularAiIcon = svgIconWrapper(SvgComponent);
